"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiTypography = getMuiTypography;
function getMuiTypography() {
  return {
    defaultProps: {
      gutterBottom: false
    },
    styleOverrides: {
      root: {
        color: '#121926',
        display: 'block'
      }
    }
  };
}